import Joi from 'joi';
import { useEffect, useState } from 'react';
import { IoArrowBackSharp } from 'react-icons/io5';
import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { Button, Col, Label, Row, Spinner } from 'reactstrap';
import ErrorMessageComponent from '../../components/ErrorMessageComponent';
import InputComponent from '../../components/InputComponent';
import PasswordCheckList from '../../components/PasswordCheckList';
import { useAuth } from '../../context/AuthContext';
import { useAvailableModulesContext } from '../../context/AvailableModulesContext';
import Toast from '../../helpers/Toast';
import { Utilities } from '../../helpers/Utilities';
import { AuthDTO } from '../../models/AuthDTO';
import { AuthService } from '../../services/AuthService';
import Banner from './Banner';

export default function Register() {
    const { reactAppName } = useAvailableModulesContext();
    const service: AuthService = new AuthService();
    const intl = useIntl();
    const { isUserLoggedIn } = useAuth();
    const navigate = useNavigate();
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [password2, setPassword2] = useState("");
    const [resultRegister, setResultRegister] = useState("");
    const [validationResult, setValidationResult] = useState<any[]>([]);
    const [Loading, setLoading] = useState(false);
    const [isPasswordValid, setIsPasswordValid] = useState(false);
    const [isConfirmPasswordValid, setIsConfirmPasswordValid] = useState(false);

    const schema = Joi.object({

        email: Joi.string().email({ tlds: { allow: false } }).required().messages({
            'string.email': intl.formatMessage({ id: "Screens.Auth.Validation.EmailFormat" }),
            'any.required': intl.formatMessage({ id: "Screens.Auth.Validation.EmailRequired" }),
            'string.base': intl.formatMessage({ id: "Screens.Auth.Validation.EmailRequired" }),
            'string.empty': intl.formatMessage({ id: "Screens.Auth.Validation.EmailRequired" }),
        }),
        name: Joi.string().required().messages({
            'any.required': intl.formatMessage({ id: "Screens.Auth.Validation.NameRequired" }),
            'string.base': intl.formatMessage({ id: "Screens.Auth.Validation.NameRequired" }),
            'string.empty': intl.formatMessage({ id: "Screens.Auth.Validation.NameRequired" }),
        }),
        password: Joi.string().pattern(Utilities.PasswordRegularExpression).min(8).required().messages({
            'any.required': intl.formatMessage({ id: "Screens.Auth.Validation.PasswordRequired" }),
            'string.base': intl.formatMessage({ id: "Screens.Auth.Validation.PasswordRequired" }),
            'string.empty': intl.formatMessage({ id: "Screens.Auth.Validation.PasswordRequired" }),
            'string.min': intl.formatMessage({ id: "Screens.Auth.Validation.PasswordMin" }),
            'string.pattern.base': intl.formatMessage({ id: "Screens.Auth.Validation.PasswordFormat" }),
        }),
        password2: Joi.string().valid(Joi.ref('password')).required().messages({
            'any.required': intl.formatMessage({ id: "Screens.Auth.Validation.PasswordRequired" }),
            'string.base': intl.formatMessage({ id: "Screens.Auth.Validation.PasswordRequired" }),
            'string.empty': intl.formatMessage({ id: "Screens.Auth.Validation.PasswordRequired" }),
            'any.only': intl.formatMessage({ id: "Screens.Auth.Validation.PasswordSame" }),
        })
    });

    const validateForm = (register: AuthDTO) => {
        return new Promise(function (resolve) {
            var validationResult = schema.validate(
                {
                    name: register.username,
                    email: register.email,
                    password: register.password,
                    password2: password2,
                }, { abortEarly: false });
            resolve(validationResult);
        });
    }

    const onClickRegisterButton = async () => {
        setLoading(true);

        const register: AuthDTO = {
            email: email,
            password: password,
            username: name,
            preferedView: "",
            technicianCode: "",
        }

        validateForm(register).then(async (result: any) => {
            if (result.error != null) {
                setValidationResult(result.error.details);
            } else {
                setValidationResult([]);

                var response = await service.Register(register);

                if (response.success === true) {

                    Toast.Show("success", response.message);

                    setLoading(false);

                    //Redirecionamos o user  
                    navigate("/login");
                }
                else {
                    setResultRegister(response.message);
                }
            }
            setLoading(false);

        }).catch(() => {
            setResultRegister("Problemas ao fazer o registo. Por favor tente novamente dentro de segundos.")
        })
        setLoading(false);
    }

    useEffect(() => {
        if (isUserLoggedIn) {
            navigate('/');
        }
    }, [isUserLoggedIn]);

    return (
        <Row style={{ display: "flex", height: "100%", margin: "0px", padding: "0px" }}>

            {/* Image on left */}
            <Banner />

            {/* Right*/}
            <Col md={6} style={{ display: "flex", alignItems: "center", alignContent: "center", justifyContent: "center", flexDirection: "column" }}>

                <Row style={{ marginBottom: "20px", width: "50%" }}>
                    <Col md={12} className="siteNameContainer">
                        <span className="siteNameBackLogo"><IoArrowBackSharp className="pageTitleBackIcon" onClick={() => { navigate("/login"); }} /></span>
                        <Label className='siteName'>{reactAppName}</Label>
                        <span style={{ flex: 1 }}></span>
                    </Col>
                </Row>

                <Row style={{ marginBottom: "20px" }}>
                    <Col md={12} className="siteWelcome">
                        <Label><FormattedMessage id="Screens.Auth.SubTitle.Register" /></Label>
                    </Col>
                </Row>

                {/* Input nome*/}
                <Row style={{ margin: "0px 0px 20px 0px", padding: "0px", minWidth: "50%" }}>
                    <InputComponent
                        xl={12}
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        style={{ textAlign: "center", width: "100%" }}
                        type={"text"}
                        value={name}
                        label={intl.formatMessage({ id: "Screens.Auth.Input.UserName" })}
                        readOnly={false}
                        onChange={(text: string) => setName(text)}
                    />
                </Row>
                <ErrorMessageComponent validationResult={validationResult} fieldToValidate="name" />

                {/* Input email*/}
                <Row style={{ margin: "0px 0px 20px 0px", padding: "0px", minWidth: "50%" }}>
                    <InputComponent
                        xl={12}
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        style={{ textAlign: "center", width: "100%" }}
                        type={"text"}
                        value={email}
                        label={intl.formatMessage({ id: "Screens.Auth.Input.Email" })}
                        readOnly={false}
                        onChange={(text: string) => setEmail(text)}
                    />
                </Row>
                <ErrorMessageComponent validationResult={validationResult} fieldToValidate="email" />

                {/* Input password*/}
                <Row style={{ margin: "0px 0px 20px 0px", padding: "0px", minWidth: "50%" }}>
                    <InputComponent
                        xl={12}
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        style={{ textAlign: "center", width: "100%" }}
                        type={"password"}
                        value={password}
                        label={intl.formatMessage({ id: "Screens.Auth.Input.Password" })}
                        readOnly={false}
                        onChange={(text: string) => setPassword(text)}
                    />
                </Row>

                <PasswordCheckList password={password}
                    shouldHaveAtLeastOneNumber={true}
                    shouldHaveAtLeastOneLowercaseLetter={true}
                    shouldHaveAtLeastOneLetter={true}
                    shouldHaveAtLeastOneSpecialChar={true}
                    shouldHaveAtLeastOneCapitalLetter={true}
                    minimumCharacters={8}
                    matchPasswords={false}
                    onChange={setIsPasswordValid}
                />
                <ErrorMessageComponent validationResult={validationResult} fieldToValidate="password" />

                {/* Input password1*/}
                <Row style={{ margin: "0px 0px 10px 0px", padding: "0px", minWidth: "50%" }}>
                    <InputComponent
                        xl={12}
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        style={{ textAlign: "center", width: "100%" }}
                        type={"password"}
                        value={password2}
                        label={intl.formatMessage({ id: "Screens.Auth.Input.RepeatPassword" })}
                        readOnly={false}
                        onChange={(text: string) => setPassword2(text)}
                    />
                </Row>

                <PasswordCheckList password={password}
                    confirmPassword={password2}
                    matchPasswords={true}
                    onChange={setIsConfirmPasswordValid}
                />
                <ErrorMessageComponent validationResult={validationResult} fieldToValidate="password2" />

                <Row>
                    <Col md={12}>
                        <label style={{ color: "red" }}>{resultRegister}</label>
                    </Col>
                </Row>

                <Row style={{ margin: "0px 0px 50px 0px", padding: "0px", minWidth: "50%" }}>
                    <Col md={12} sm={12} xs={12} lg={12} style={{ textAlign: "center" }}>
                        <Row className="loginbuttons" style={{ margin: "0px", padding: "0px", minWidth: "50%" }}>
                            {
                                Loading === true ?
                                    <Col md={12} sm={12} xs={12} lg={12} style={{ textAlign: "center" }}>
                                        <Spinner color="primary" />
                                    </Col>
                                    :
                                    <Col md={12} sm={12} xs={12} lg={12} style={{ textAlign: "center" }}>
                                        <Button disabled={isPasswordValid === false || isConfirmPasswordValid === false} className="createaccount" onClick={onClickRegisterButton}><FormattedMessage id="Screens.Auth.Button.Register" /></Button>
                                    </Col>
                            }
                        </Row>
                    </Col>
                </Row>
            </Col>
        </Row>
    )
}
